module.exports = __webpack_public_path__ + "img/weather_thunder.d6a9d699.png";